module.exports = __webpack_public_path__ + "img/image_11.6aa260d3.png";